// import React, { useRef, useEffect } from "react";
// import { Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
// } from "chart.js";

// ChartJS.register(CategoryScale, LinearScale, BarElement);

// const Test = () => {
//   const chartRef = useRef(null);

//   const data = {
//     labels: ["0%", "30%", "40%", "50%", "70%", "90%", "100%"],
//     datasets: [
//       {
//         label: "Progress",
//         data: [0, 30, 40, 50, 70, 90, 100],
//         backgroundColor: (context) => {
//           const chart = context.chart;
//           const { ctx, chartArea } = chart;

//           if (!chartArea) {
//             // This case happens on initial chart load
//             return null;
//           }
//           const gradient = ctx.createLinearGradient(
//             chartArea.left,
//             0,
//             chartArea.right,
//             0
//           );
//           gradient.addColorStop(0, "rgba(255, 159, 64, 0.8)");
//           gradient.addColorStop(1, "rgba(255, 159, 64, 0.1)");
//           return gradient;
//         },
//         borderColor: [
//           "rgba(255, 159, 64, 1)",
//           "rgba(255, 159, 64, 1)",
//           "rgba(255, 159, 64, 1)",
//           "rgba(255, 159, 64, 1)",
//           "rgba(255, 159, 64, 1)",
//           "rgba(255, 159, 64, 1)",
//           "rgba(255, 159, 64, 1)",
//         ],
//         borderWidth: 1,
//         barPercentage: 0.8, // Adjust the width of the bars
//         categoryPercentage: 0.8, // Adjust the spacing between bars
//       },
//     ],
//   };

//   const options = {
//     indexAxis: "y", // This makes the bar chart horizontal
//     scales: {
//       x: {
//         beginAtZero: true,
//         max: 100, // Ensure the max value is 100 to reflect percentage
//       },
//     },
//     plugins: {
//       legend: {
//         display: false, // Hide the legend if you only have one dataset
//       },
//     },
//   };

//   return <Bar ref={chartRef} data={data} options={options} />;
// };

// export default Test;

import React, { useState } from "react";

const Test = () => {
  const [transcript, setTranscript] = useState("");
  const [translation, setTranslation] = useState("");
  const [isListening, setIsListening] = useState(false);

  const recognition = new (window.SpeechRecognition ||
    window.webkitSpeechRecognition)();
  recognition.continuous = false;
  recognition.interimResults = false;
  recognition.lang = "auto"; // Detect language automatically

  const startListening = () => {
    setIsListening(true);
    recognition.start();

    recognition.onresult = async (event) => {
      const speechText = event.results[0][0].transcript;
      console.log("Heard:", speechText);
      setTranscript(speechText);
      await translateToEnglish(speechText);
    };

    recognition.onend = () => {
      setIsListening(false);
    };

    recognition.onerror = (event) => {
      console.error("Speech recognition error:", event.error);
      setIsListening(false);
    };
  };

  const translateToEnglish = async (text) => {
    try {
      const res = await fetch(
        "https://corsproxy.io/?" +
          encodeURIComponent("https://libretranslate.de/translate"),
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            q: text,
            source: "auto",
            target: "en",
            format: "text",
          }),
        }
      );

      const data = await res.json();
      console.log("Translation API Response:", data);
      setTranslation(data.translatedText || "[No translation]");
    } catch (err) {
      console.error("Translation error:", err);
      setTranslation("[Error in translation]");
    }
  };

  return (
    <div style={{ padding: "20px", fontFamily: "Arial" }}>
      <h2>🎙️ Speech Translator</h2>
      <button onClick={startListening} disabled={isListening}>
        {isListening ? "Listening..." : "Start Speaking"}
      </button>
      <div style={{ marginTop: "20px" }}>
        <p>
          <strong>Original (any language):</strong> {transcript}
        </p>
        <p>
          <strong>English Translation:</strong> {translation}
        </p>
      </div>
    </div>
  );
};

export default Test;
